<template>
  <div class="form-group form-group--read-only">
    <div class="row">
      <div v-bind:class="`col-sm-${component.size}`">
        <label v-if="!component.hideLabel">{{ component.label }}</label>
        <div class="lead">
          <span class="prefix" v-if="component.prefix">{{ component.prefix }}</span>
          <span class="text">{{ getValue() }}</span>
          <li v-for="label in labels" v-bind:key="label">{{label}}</li>
          <span class="suffix" v-if="component.suffix">{{ component.suffix }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      labels: []
    }
  },
  props: ['component', 'components', 'value'],
  name: 'Select-Recurso-ReadOnly',
  methods: {
    getValue: function () {
      if (!(Array.isArray(this.value))) {
        return this.value && this.value.hasOwnProperty('label') ? this.value.label : '-'
      }
    }
  },
  created () {
    if (Array.isArray(this.value)) {
      this.value.forEach(el => this.labels.push(el.label))
      return this.labels
    }
  }
}
</script>
